module.exports = __webpack_public_path__ + "08_mole.17e9e1ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer2/08_mole.png
// module id = w0tC
// module chunks = 0